import { RoleNome } from '../generated/backend-enums.js';
export { RoleNome };
export const RoleLabelsMap = {
    [RoleNome.ADMIN]: 'Administrador',
    [RoleNome.OPERADOR]: 'Operador',
    [RoleNome.CEO]: 'CEO (Chief Executive Officer)',
    [RoleNome.CTO]: 'CTO (Chief Technology Officer)',
    [RoleNome.CFO]: 'CFO (Chief Financial Officer)',
    [RoleNome.CBO]: 'CBO (Chief Business Officer)',
    // Cargos de Atendimento
    [RoleNome.DIRETOR_DE_NEGOCIOS]: 'Diretor de Negócios',
    [RoleNome.GERENTE_DE_ATENDIMENTO]: 'Gerente de Atendimento',
    [RoleNome.COORDENADOR_DE_ATENDIMENTO]: 'Coordenador de Atendimento',
    [RoleNome.DIRETOR_DE_PROJETOS]: 'Diretor de Projetos',
    [RoleNome.ATENDIMENTO]: 'Atendimento',
    [RoleNome.ASSISTENTE_DE_ATENDIMENTO]: 'Assistente de Atendimento',
    [RoleNome.ESTAGIARIO_DE_ATENDIMENTO]: 'Estagiário de Atendimento',
    [RoleNome.USER]: 'Usuário',
    // Cargos de Pré-Produção e Compras
    [RoleNome.HEAD_PRE]: 'Head de Pré-Produção',
    [RoleNome.HEAD_COMPRAS]: 'Head de Compras',
    [RoleNome.PRE_PRODUTOR]: 'Pré-Produtor',
    [RoleNome.PRE_PRODUTOR_FREELA]: 'Pré-Produtor Freelance',
    [RoleNome.DIRETOR_PRODUCAO]: 'Diretor de Produção',
    // Cargos de Produção
    [RoleNome.COMPRADOR]: 'Comprador',
    [RoleNome.PRODUTOR]: 'Produtor',
    [RoleNome.PRODUTOR_FINANCEIRO]: 'Produtor Financeiro',
    [RoleNome.GESTOR_PRODUCAO_GRAFICA]: 'Gestor de Produção Gráfica',
    [RoleNome.PRODUTOR_GRAFICO]: 'Produtor Gráfico',
    // Cargos Financeiros
    [RoleNome.FINANCEIRO]: 'Financeiro',
    [RoleNome.ASSISTENTE_FINANCEIRO]: 'Assistente Financeiro',
    // Cargos de Planejamento
    [RoleNome.CSO]: 'CSO (Chief Strategy Officer)',
    [RoleNome.HEAD_PLANEJAMENTO]: 'Head de Planejamento',
    [RoleNome.PLANNER]: 'Planner',
    // Cargos de Tecnologia
    [RoleNome.GESTOR_TI]: 'Gestor de TI',
    [RoleNome.ANALISTA_TI]: 'Analista de TI',
    [RoleNome.AUDITOR]: 'Auditor',
    // Cargos de Controladoria
    [RoleNome.CONTROLADOR]: 'Controlador',
    // Cargos de Criação
    [RoleNome.HEAD_CRIACAO]: 'Head de Criação',
    [RoleNome.REDATOR]: 'Redator',
    [RoleNome.DIRETOR_DE_ARTE]: 'Diretor de Arte',
    [RoleNome.ARTE_FINALISTA]: 'Arte Finalista',
    [RoleNome.ARTISTA_3D]: '3D',
    // Cargos Administrativos (Facilities)
    [RoleNome.GESTORA_ADMINISTRATIVA]: 'Gestora Administrativa',
    [RoleNome.ADMINISTRATIVO]: 'Administrativo',
};
